import { DocumentVariableListPageDocument } from 'generated/resources/graphql'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useQuery } from 'modules/core/hooks/useQuery'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import AllAvailableVariablesList from 'modules/documents/components/DocumentTemplates/Content/AllAvailableVariablesList'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const VariableTemplatesPage = () => {
  const { loading, data, error } = useQuery(DocumentVariableListPageDocument, {})
  const { loading: loadingContractVersions } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  const authorized = !loading && data?.documents?._policies?.templateManageDocumentTemplates.can

  return (
    <ResponsivePage.Body
      variant="full"
      loading={loading || loadingContractVersions}
      error={error}
      showHeader={false}
      authorized={authorized}
    >
      <AllAvailableVariablesList contractVersions={contractVersions} />
    </ResponsivePage.Body>
  )
}

export default VariableTemplatesPage
